module.exports = __webpack_public_path__ + "static/media/kml16.ae352725.svg";